import classNames from 'classnames';

import './no-data.scss';

const NoData = ({ t, className, variant = 'platform', title }) => {
  return (
    <div
      className={classNames(
        'no-data',
        {
          'no-data--platform': variant === 'platform',
          'no-data--web': variant === 'web',
        },
        className,
      )}
    >
      {title ? title : t('text.empty-data')}
    </div>
  );
};

export default NoData;
